module.exports = __webpack_public_path__ + "img/gouxuan.70f03527.png";